import LocationDataSchema from "@lts-web/schemas/LocationDataSchema";

class LocationData {
    constructor(data = {}) {
        this._data = Object.freeze(LocationDataSchema(data));

        Reflect.defineProperty(this, '_data', {
            writable: false,
            configurable: false,
            enumerable: false
        });
    }

    /**
     * Get location data
     * @return {Readonly<{LocationDataSchema}>}
     */
    getData() {
        return this._data;
    }

    /**
     * Get data property
     * @param propertyKey
     * @return {*}
     */
    getDataProperty(propertyKey) {
        return this._data[propertyKey];
    }

    /**
     * Get system type
     * @return {symbol[]}
     */
    getSystemTypes() {
        return this._data.systemTypes;
    }

    /**
     * Get location type
     * @return {symbol}
     */
    getLocationType() {
        return this._data.locationType;
    }

    /**
     * Get city code
     * @return {string}
     */
    getCityCode() {
        return this._data.cityCode;
    }

    /**
     * Get city name
     * @return {string}
     */
    getCityName() {
        return this._data.cityName;
    }

    /**
     * Get country code
     * @return {string}
     */
    getCountryCode() {
        return this._data.countryCode;
    }

    /**
     * Get country name
     * @return {string}
     */
    getCountryName() {
        return this._data.countryName;
    }

    /**
     * Get airport code
     * @return {string}
     */
    getAirportCode() {
        return this._data.airportCode;
    }

    /**
     * Get airport name
     * @return {string}
     */
    getAirportName() {
        return this._data.airportName;
    }

    /**
     * Get hotel code
     * @return {string}
     */
    getHotelCode() {
        return this._data.hotelCode;
    }

    /**
     * Get hotel name
     * @return {string}
     */
    getHotelName() {
        return this._data.hotelName;
    }

    /**
     * Get image src
     * @return {string}
     */
    getImageSrc() {
        return this._data.imageSrc;
    }
}

export default LocationData;